import { Loader2 } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface QrCodePanelProps {
  /** The kind of code shown, as a badge above it. */
  badge: string;
  /** The code's image (a data or hosted URL). */
  src: string;
  alt: string;
  /** What to do with the code. */
  hint: string;
  /** Shown with a spinner under the hint while the status is being polled; omitted when not polling. */
  pollingNote?: string;
}

/** A BankID QR code with its badge, instruction and live-polling note. */
export function QrCodePanel({ badge, src, alt, hint, pollingNote }: QrCodePanelProps) {
  return (
    <div className="space-y-4">
      <div className="text-center">
        <Badge variant="outline" className="mb-2">{badge}</Badge>
      </div>
      <div className="flex justify-center">
        <img src={src} alt={alt} className="w-64 h-64 border rounded-lg" />
      </div>
      <p className="text-xs text-muted-foreground text-center">
        {hint}
        {pollingNote && (
          <span className="block mt-1">
            <Loader2 className="h-3 w-3 animate-spin inline mr-1" />
            {pollingNote}
          </span>
        )}
      </p>
    </div>
  );
}
